import { CrudSort } from "@refinedev/core";
import { FiltersButton } from "./DetailedSearch/FiltersButton";
import { useTranslation } from "../../../../hooks/useTranslation";
import { BaseListFilterRow } from "../../../../components/BaseListFilterRow";

type Props = {
  sorters: CrudSort[];
  marketplaceProductStatus: string;
  storeProductStatus: string;
};

export const ProductListFilterRow = ({
  sorters,
  marketplaceProductStatus,
  storeProductStatus,
}: Props) => {
  const { translate } = useTranslation();

  const showFilterButton =
    marketplaceProductStatus === "ACTIVE" &&
    [
      "PENDING_APPROVE",
      "ACTIVE",
      "INACTIVE",
      "INCOMPLETE",
      "ACCEPTED",
    ].includes(storeProductStatus);

  return (
    <BaseListFilterRow
      placeholder={translate(
        "pages.inventoryManagement.inventory.list.filters.search",
      )}
      sorters={sorters}
      exportUrl="product/export"
      showFiltersButton={
        showFilterButton ? (
          <FiltersButton
            isPendingApprove={storeProductStatus === "PENDING_APPROVE"}
          />
        ) : null
      }
    />
  );
};
